export enum RouterEnum {
  LOGIN = '/login',
  SPOTS = '/spots',
  PROFILE = '/profile',
}
